/**
 * @generated SignedSource<<b3e214fc70956c2d2b2560bca5be1c5c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedBottomModuleSpacer_bottomModule$data = ReadonlyArray<{
  readonly __typename: "BottomModule";
  readonly " $fragmentType": "SharedBottomModuleSpacer_bottomModule";
}>;
export type SharedBottomModuleSpacer_bottomModule$key = ReadonlyArray<{
  readonly " $data"?: SharedBottomModuleSpacer_bottomModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModuleSpacer_bottomModule">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedBottomModuleSpacer_bottomModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "BottomModule",
  "abstractKey": null
};

(node as any).hash = "b7f4a3d9e5d2de05414c870fef846117";

export default node;
